export default "__VITE_ASSET__c96a7872__"